export function filterItems(items, filters, search_query){
  let filter_date_from = "";
  let filter_date_to = "";
  let checkbox_filters = {};
  let top_filters = {};

  // let top_filter = "";

  filters.forEach((filter) => {

    if (filter.type === "date"){
      filter.elements.forEach(element => {
        if (element.id === "date_from"){
          filter_date_from = (parseInt(element.value) / 1000)  ;
        }
        if (element.id === "date_to"){
          filter_date_to = (parseInt(element.value) / 1000);
        }
      });
    }

    if (filter.type === "checkboxes"){

      filter.elements.forEach(element => {
        if (element.value){

          if (typeof checkbox_filters[element.parent] != "undefined"){
            checkbox_filters[element.parent].push(element.id);
          } else {
            checkbox_filters[element.parent] = [element.id];
          }

        }
      });

    }

    if (filter.type === "top"){
      filter.elements.forEach(element => {

        if (element.value){

          top_filters[element.parent_tag] = [element.id];
        }
      });
    }
  })

  let filtered_items = items.filter(item => {

    let visible = true;

    if (Object.keys(top_filters).length){
      for (var top_filter in top_filters) {
        let t = top_filters[top_filter];

        if (t[0] === "all"){
          visible = true;
        } else {
          if (typeof item.tags[top_filter] === "undefined"){
            visible = false;
          } else {
            visible =  item.tags[top_filter].some(r=> t.includes(r))
          }
        }

      }
    }

    if (search_query.length >= 2){
      let in_search = item.search_data.toLowerCase().indexOf(search_query.toLowerCase()) > -1 || !search_query.length
      if (!in_search){
        visible = false;
      }
    }


    let performances = "";

    if (item.performances.length){
      performances = JSON.parse(item.performances);

      let date_from = 0;
      let date_to = 0;

      if (filter_date_from){

        let has_performances = false;
        for (const property in performances) {
          let times = performances[property].times;
          for (const time in times) {
            let item_time = new Date(parseInt(time) * 1000).setHours(0,0,0,0);
            item_time = parseInt(item_time) / 1000;

            if (filter_date_to){
              if ( item_time >=  filter_date_from && item_time <= filter_date_to){
                has_performances = true;
              }
            } else {

              if ( item_time >=  filter_date_from){
                has_performances = true;
              }
            }
          }
        }
        if (!has_performances){
          visible = false;
        }

      }

    } else {

      let date_from = 0;
      let date_to = 0;
      let is_in_range = false;
      if (filter_date_from){

        if (item.start_date.length){
          date_from = new Date(parseInt(item.start_date) * 1000).setHours(0,0,0,0);
          date_from = parseInt(date_from) / 1000;
        }
        if (item.end_date.length){
          date_to = new Date(parseInt(item.end_date) * 1000).setHours(0,0,0,0);
          date_to = parseInt(date_to) / 1000;
        }



        if (date_from >= filter_date_from && date_to <= filter_date_to){
          is_in_range = true;
        }

        if (!is_in_range){
          visible = false;
        }
      }






      // console.log(item, filter_date_from, filter_date_to);

    }

    if (Object.keys(checkbox_filters).length && visible){
      for (var checkbox_filter in checkbox_filters) {
        let f = checkbox_filters[checkbox_filter];
        if (typeof item.tags[checkbox_filter] === "undefined"){
          visible =  false;
        } else {
          visible =  item.tags[checkbox_filter].some(r=> f.includes(r))
        }
      }
    }




    return visible;



  });

  return filtered_items;
}
